import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class SharedService {

    constructor(private http: HttpClient) { };

    private dataSource = new Subject<any[]>();
    public sideNavExpanded: boolean;
    public menuItems = new BehaviorSubject<any[]>([]);
    public preparedMenuItems = new BehaviorSubject<any[]>([]);
    public moduleId = new Subject<number>().next(28);
    public emptyRow = new Subject<any>();
    public screenPermissionsList = new BehaviorSubject<any[]>([]);
    public currentRoute = new BehaviorSubject<any>(null);
    public callToActions = new BehaviorSubject<any>(null);
    SECRET_KEY = '@-[3-)p7AZ[IFMfOUR-.`|%tAH6SaQrQ.y_M|ksj$|7:?~B!&`bGO1X6eq_(1FmJ';
    public reportActions = new BehaviorSubject<any>(null);
    public notificationSettingsActions = new BehaviorSubject<any>(null);
    public normalReportActions = new BehaviorSubject<any>(null);
    addCardHolderPermission: any;
    public forceChangePassword = new BehaviorSubject<any>(false);
    public configurations = new BehaviorSubject<any>(null);
    public keys = new BehaviorSubject<any>(null);
    public IscheckforceChangePassword = new BehaviorSubject<any>(null);
    public usermanagementActions = new BehaviorSubject<any>(null);
    public activeUser = new BehaviorSubject<any>(null);
    public pendingHTTPRequests$ = new Subject<void>();
    public regions = new BehaviorSubject<any>({});
    public declinedReasonsChanged = new BehaviorSubject<any>(null);
    public serviceItemFieldChanged = new BehaviorSubject<any>(null);
    public serviceItemFieldUpdated = new BehaviorSubject<any>(null);
    public updatedServiceItem = new BehaviorSubject<any>(null);
    public deleteSelectedServiceItem = new BehaviorSubject<any>(null);
    public getNextClaimsInformation = new BehaviorSubject<any>(null);
    public setAllClaimsInformation = new BehaviorSubject<any>(null);
    public executeEnableDisableTOB1TOB2Fields = new BehaviorSubject<any>(null);
    public appliedBenefitsTOB2CustomValidations = new BehaviorSubject<any>(null);
    public downloadFile = new BehaviorSubject<any>(null);
    // public selectedRow = new BehaviorSubject<any>(null);
    public contentChanged = new BehaviorSubject<any>(null);
    public forwardByMailContentChanged = new BehaviorSubject<any>(null);

    //to set edit state 
    public setRowEditStatus = new BehaviorSubject<number>(null);
    public callListApiAfterUpload = new BehaviorSubject<boolean>(false);

    // File uploading status data
    private fileUploadingData = new Subject<boolean>();
    public fileUploading = this.fileUploadingData.asObservable();

    currentIndexOfRow = this.setRowEditStatus.asObservable();
    isExcelFileUploaded = this.callListApiAfterUpload.asObservable();

    public isQuestionnaireChanged = false;
    public isStepOneChanged = false;
    public isStepThreeChanged = false;
    // eslint-disable-next-line @typescript-eslint/ban-types
    public autoTriggerFlag = new BehaviorSubject<Object>({ triggeredFunctionName: '', flag: false });
    public previousTasoapplanitems: any[] = [];
    
    public newRowAdded = false;
    public locale = '';
    public dateFormat = '';
    public openedSearchUrl: any[] = [];

    public org = {
        OrgAdmissionDate : null,
        OrgDischargeDate : null,
	    OrgLOS : null,
	    OrgFOBID : null,
	    OrgProvider : null,
        OrgICDs: null,
        OrgCpts: null
    }

    public mdWeightValue : any = null;
    public mlWeightUnit : any = null;
    public aCPTs: any = [];
    public mbShouldCallBatchGrouper: any = null;

    /* forward by email global variables */
    public bReplyToAll: boolean = false;
    public sSenderEmail: string = null;
    public sSubject: string = null;
    public sCCEmails: string = null;
    public bEmail: boolean = false;
    public checkIfFaxNoExists: boolean = false;
    /* forward by email global variables */
    
    private businessTransactionsParameterData = new BehaviorSubject<any>(null);
    private partnersParameterData = new BehaviorSubject<any>(null);
    private boilerPlateParameterData = new BehaviorSubject<any>(null);
    updateLocale(locale: any) {
        this.locale = locale;
    }
    getLocale() {
        return this.locale;
    }
    updateDateFormate(dateFormat: any) {
        this.dateFormat = dateFormat;
    }
    getDateFormat() {
        return this.dateFormat;
    }



    AddDataSource(data: any) {
        this.dataSource.next(data);
    }

    clearMessage() {
        this.dataSource.next();
    }

    getDataSource(): Observable<any> {
        return this.dataSource.asObservable();
    }

    addMenuItems(menuItemList: any) {
        ///this.menuItems.next(null);
        this.menuItems.next(menuItemList);
    }

    public getMenuItems(): Observable<any> {
        return this.menuItems.asObservable();
    }

    getEmptyRow(): Observable<any> {
        return this.emptyRow.asObservable();
    }

    public getPraparedMenuItem(): Observable<any> {
        return this.preparedMenuItems.asObservable();
    }

    updatePeaparedMenuItem(data: any) {
        //this.menuItems.next(null);
        this.preparedMenuItems.next(data);
    }

    addScreenPermissionsList(data: any) {
        this.screenPermissionsList.next(data);
    }
    getScreenPermssionList() {
        return this.screenPermissionsList.asObservable();
    }
    addCurrentRoute(data: any) {
        this.currentRoute.next(data);
    }
    getCurrentRoute() {
        return this.currentRoute.asObservable();
    }

    addCallToactions(data: any) {
        this.callToActions.next(data);
    }
    getCallToactions() {
        // debugger
        return this.callToActions.asObservable();
    }

    addReportActions(data: any) {
        this.reportActions.next(data);
    }
    getReportActions() {
        return this.reportActions.asObservable();
    }
    addNotificationSettingsActions(data: any) {
        this.notificationSettingsActions.next(data);
    }
    getNotificationSettingsActions() {
        return this.notificationSettingsActions.asObservable();
    }
    addNormalReportActions(data: any) {
        this.normalReportActions.next(data);
    }
    getNormalReportActions() {
        return this.normalReportActions.asObservable();
    }
    addCardHolder(data: any) {
        this.addCardHolderPermission.next(data);
    }
    getAddCardHolder() {
        return this.addCardHolderPermission.asObservable();
    }
    updateForceChangePassword(data: any) {
        this.forceChangePassword.next(data);
    }
    getForceChangePassword() {
        return this.forceChangePassword.asObservable();
    }
    checkForceChangePassword() {
        return this.IscheckforceChangePassword.asObservable();
    }
    updateCheckForceChangePassword(data: any) {
        return this.IscheckforceChangePassword.next(data);
    }

    /**Important setting config files*/
    updateConfig(data: any) {
        this.configurations.next(data);
    }
    getConfig() {
        return this.configurations.asObservable();
    }
    /**Important setting keys forn EVO.config file*/
    updateKeys(data: any) {
        this.keys.next(data);
    }
    getKeys() {
        return this.keys.asObservable();
    }
    updateUserListActions(data: any) {
        this.usermanagementActions.next(data);
    }
    getUserListActions() {
        return this.usermanagementActions.asObservable();
    }
    getCurrentActiveUser() {
        return this.activeUser.asObservable();
    }
    updateCurrentActiveUser(data: any) {
        this.activeUser.next(data);
    }

    // Cancel Pending HTTP calls
    public cancelPendingRequests() {
        this.pendingHTTPRequests$.next();
    }

    public onCancelPendingRequests() {
        return this.pendingHTTPRequests$.asObservable();
    }

    

    addRegions(data: any) {
        this.regions.next(data);
    }

    getRegions() {
        return this.regions.asObservable();
    }

    declinedReasonsOnChange() {
        return this.declinedReasonsChanged.asObservable();
    }

    serviceItemFieldOnChange(): Observable<any> {
        return this.serviceItemFieldChanged.asObservable();
    }

    setServiceItemField(data: any) {
        this.serviceItemFieldChanged.next(data);
    }

    updateServiceItemFieldOnChange(): Observable<any> {
        return this.serviceItemFieldUpdated.asObservable();
    }

    updateServiceItemField(data: any) {
        this.serviceItemFieldUpdated.next(data);
    }

    setUpdatedServiceItem(data: any) {
        this.updatedServiceItem.next(data);
    }

    getUpdatedServiceItem(): Observable<any> {
        return this.updatedServiceItem.asObservable();
    }

    deleteServiceItem(data: any) {
        this.deleteSelectedServiceItem.next(data);
    }

    getServiceItemToDelete(): Observable<any> {
        return this.deleteSelectedServiceItem.asObservable();
    }

    getNextClaimsInformationOnChange(): Observable<any> {
        return this.getNextClaimsInformation.asObservable();
    }

    setAllClaimsInformationOnChange(): Observable<any> {
        return this.setAllClaimsInformation.asObservable();
    }

    setRowEditStatusOnChange(currentIndex) {
        this.setRowEditStatus.next(currentIndex);
    }

    setFlagForUploadedExcelFile(isFileUploaded: boolean) {
        this.callListApiAfterUpload.next(isFileUploaded);
    }

    /* used to call EnableDisableTOB1TOB2Fields function in create-new-claim from Adjudication Results Popup */
    callEnableDisableTOB1TOB2Fields(data) {
        this.executeEnableDisableTOB1TOB2Fields.next(data);
    }

    executeEnableDisableTOBFunction(): Observable<any> {
        return this.executeEnableDisableTOB1TOB2Fields.asObservable();
    }
    /* used to call EnableDisableTOB1TOB2Fields function in create-new-claim from Adjudication Results Popup */

    /* used to send the applied benefits validations to  Adjudication Results Popup from create-new-claim */

    setAppliedBenefitsValidations(data) {
        this.appliedBenefitsTOB2CustomValidations.next(data);
    }

    getAppliedBenefitsValidations(): Observable<any> {
        return this.appliedBenefitsTOB2CustomValidations.asObservable();
    }

    getQuickMenuSettings(Service: string) {
        try {
            return this.http.get<any>(
                "/assets/json/Design/QuickMenu/" + Service + ".json"
            );
        } catch (ex) {
            return null;
        }
    }
    /* used to send the applied benefits validations to  Adjudication Results Popup from create-new-claim */

    setDownLoadFile(data) {
        this.downloadFile.next(data);
    }

    getDownLoadFile(): Observable<any> {
        return this.downloadFile.asObservable();
    }

    onChangeOfContent(): Observable<any> {
        return this.contentChanged.asObservable();
    }

    setContent(data: any) {
        this.contentChanged.next(data);
    }

    onChangeOfForwardByMailContent(): Observable<any> {
        return this.forwardByMailContentChanged.asObservable();
    }

    setForwardByMailContent(data: any) {
        this.forwardByMailContentChanged.next(data);
    }
    
    getbusinessTransactionsParameterData(): Observable<any> {
        this.businessTransactionsParameterData = new BehaviorSubject<any>(null);
        if (this.businessTransactionsParameterData.value == null || this.businessTransactionsParameterData.value == undefined) {
            this.businessTransactionsParameterData.next(JSON.parse(sessionStorage.getItem("BusTrxParameter")));
        }
        return this.businessTransactionsParameterData.asObservable();
    }
    getPartnersParameterData(): Observable<any> {
        this.partnersParameterData = new BehaviorSubject<any>(null);
        if (this.partnersParameterData.value == null || this.partnersParameterData.value == undefined) {
            this.partnersParameterData.next(JSON.parse(sessionStorage.getItem("partnerParameter")));
        }
        return this.partnersParameterData.asObservable();
    }
    getBoilerPlateParameterData(): Observable<any> {
        this.boilerPlateParameterData = new BehaviorSubject<any>(null);
        if(this.boilerPlateParameterData.value == null || this.boilerPlateParameterData.value == undefined){
            this.boilerPlateParameterData.next(JSON.parse(sessionStorage.getItem("boilerPlateParameter")));
        }
        return this.boilerPlateParameterData.asObservable();
    }

    callToUploadingFile() {
        this.fileUploadingData.next();
    }
}

